export default function MonitoringLayout({ children }: { children: React.ReactNode }) {
    return (
        <main
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                // minHeight: "100vh",
            }}
        >
            {children}
        </main>
    );
}
